import {useMutation} from '@apollo/react-hooks';

import type {
    setGoogleMailSendIsEnabled as SetGoogleMailSendIsEnabledMutation,
    setGoogleMailSendIsEnabledVariables as SetGoogleMailSendIsEnabledMutationVariables,
} from 'nutshell-graphql-types';

import SET_GOOGLE_MAIL_SEND_IS_ENABLED from '../mutations/set-google-mail-send-is-enabled.graphql';

export function useSetGoogleMailSendIsEnabled() {
    const [enableGoogle, {loading}] = useMutation<
        SetGoogleMailSendIsEnabledMutation,
        SetGoogleMailSendIsEnabledMutationVariables
    >(SET_GOOGLE_MAIL_SEND_IS_ENABLED);

    return {
        enableGoogle,
        isLoading: loading,
    };
}
